/**
 * URL 规范化处理
 * 确保 URL 格式正确
 */
export function normalizeUrl(url: string): string {
  if (!url) {
    return '';
  }

  // 移除首尾空格
  url = url.trim();

  // 如果没有协议，添加 https://
  if (!url.match(/^https?:\/\//i)) {
    url = 'https://' + url;
  }

  return url;
}

/**
 * 验证 URL 格式
 */
export function isValidUrl(url: string): boolean {
  try {
    new URL(url);
    return true;
  } catch {
    // 如果不是完整 URL，尝试添加 https://
    try {
      new URL(`https://${url}`);
      return true;
    } catch {
      return false;
    }
  }
}

/**
 * 检测是否为内网地址
 */
export function isInternalUrl(url: string): boolean {
  try {
    const normalized = normalizeUrl(url);
    const urlObj = new URL(normalized);
    const hostname = urlObj.hostname.toLowerCase();
    
    // 检测 localhost
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1') {
      return true;
    }
    
    // 检测内网IP地址范围
    // 192.168.x.x
    if (/^192\.168\./.test(hostname)) {
      return true;
    }
    
    // 10.x.x.x
    if (/^10\./.test(hostname)) {
      return true;
    }
    
    // 172.16.x.x - 172.31.x.x
    if (/^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(hostname)) {
      return true;
    }
    
    // 检测是否为IP地址格式（IPv4）
    const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/;
    if (ipv4Regex.test(hostname)) {
      return true;
    }
    
    return false;
  } catch {
    return false;
  }
}

/**
 * 获取网站 favicon URL（多层fallback策略）
 */
export function getFaviconUrl(url: string): string {
  if (!url) return '';
  
  try {
    const normalized = normalizeUrl(url);
    const urlObj = new URL(normalized);
    
    // 对于内网地址，直接尝试访问网站的 /favicon.ico
    if (isInternalUrl(normalized)) {
      return `${urlObj.origin}/favicon.ico`;
    }
    
    // 对于公网地址，优先使用Google的favicon服务（更可靠）
    return `https://www.google.com/s2/favicons?domain=${urlObj.hostname}&sz=64`;
  } catch {
    return '';
  }
}

/**
 * 获取网站直接favicon URL（作为备选方案）
 */
export function getDirectFaviconUrl(url: string): string {
  if (!url) return '';
  
  try {
    const normalized = normalizeUrl(url);
    const urlObj = new URL(normalized);
    return `${urlObj.origin}/favicon.ico`;
  } catch {
    return '';
  }
}

/**
 * 获取Google favicon服务URL（作为备选方案）
 */
export function getGoogleFaviconUrl(url: string): string {
  try {
    const urlObj = new URL(normalizeUrl(url));
    return `https://www.google.com/s2/favicons?domain=${urlObj.hostname}&sz=64`;
  } catch {
    return '';
  }
}
